// extracted by mini-css-extract-plugin
export default {"spinner":"styles-module_spinner_gZaQIl","spinning-full":"styles-module_spinning-full__ExCUC","spinningFull":"styles-module_spinning-full__ExCUC"};